import angular from 'angular';

function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('suppliers', {
    url: '/suppliers',
    templateProvider: () =>
      import(/* webpackChunkName: "suppliers" */ './suppliers.pug').then(
        ({ default: tpl }) => tpl,
      ),
    controller: 'suppliersCtrl as vm',
    requiredPermission: 'suppliers',
    resolve: {
      loadCtrl: $ocLazyLoad =>
        Promise.all([
          import(/* webpackChunkName: "suppliers" */ './suppliers.controller'),
          import('../../extensions/init/ag-grid'),
        ]).then(([module]) => {
          $ocLazyLoad.load({ name: module.name });
          return module.controller;
        }),
    },
  });
}

export default angular.module('app.suppliers.routing', []).config(routes);
